module.exports = __webpack_public_path__ + "img/red_049.6c3cb646.png";